<h1 mat-dialog-title [translate]="'UI.Profile'"></h1>

@if (isFormSubmitted || (isLoading$ | async) === false) {
  <form [formGroup]="profileForm" (ngSubmit)="save()">
    <mat-dialog-content>
      @if (serverError) {
        <h2 mat-dialog-title [translate]="'UI.CheckPassword'" class="error cf-flex-row cf-justify-content-start cf-align-items-center"></h2>
      }

      <section class="profile-form cf-flex-column cf-justify-content-start cf-align-items-start cf-align-items-stretch">
        <mat-form-field class="form-field">
          <mat-label [translate]="'UI.Email'"></mat-label>
          <input type="email" matInput formControlName="email" aria-label="username" required />
        </mat-form-field>
        <mat-form-field class="form-field">
          <mat-label [translate]="'UI.FirstName'"></mat-label>
          <input type="text" matInput formControlName="firstName" aria-label="first name" required />
          @if (firstName.invalid && (firstName.dirty || firstName.touched) && firstName.errors.required) {
            <mat-error [translate]="'UI.Error.Required'"></mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-field">
          <mat-label [translate]="'UI.LastName'"></mat-label>
          <input type="text" matInput formControlName="lastName" aria-label="last name" required />
          @if (lastName.invalid && (lastName.dirty || lastName.touched) && lastName.errors.required) {
            <mat-error [translate]="'UI.Error.Required'"></mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-field">
          <mat-label [translate]="'UI.Company'"></mat-label>
          <input type="text" matInput formControlName="company" aria-label="company" required />
          @if (company.invalid && (company.dirty || company.touched) && company.errors.required) {
            <mat-error [translate]="'UI.Error.Required'"></mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-field">
          <mat-label [translate]="'UI.OldPassword'"></mat-label>
          <input type="password" matInput formControlName="oldPassword" aria-label="old password" />
          @if (oldPassword.errors?.required) {
            <mat-error [translate]="'UI.Error.Required'"></mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-field">
          <mat-label [translate]="'UI.NewPassword'"></mat-label>
          <input type="password" matInput formControlName="newPassword" aria-label="new password" />
          @if (newPassword.errors?.required) {
            <mat-error [translate]="'UI.Error.Required'"></mat-error>
          }
          @if (newPassword.errors?.compare) {
            <mat-error [translate]="'UI.Error.PasswordMismatch'"></mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-field">
          <mat-label [translate]="'UI.ConfirmPassword'"></mat-label>
          <input type="password" matInput formControlName="confirmPassword" aria-label="confirm password" />
          @if (confirmPassword.errors?.compare) {
            <mat-error [translate]="'UI.Error.PasswordMismatch'"></mat-error>
          }
        </mat-form-field>
      </section>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button type="button" mat-button mat-dialog-close [disabled]="isLoading$ | async">
        <span>{{ 'UI.Cancel' | translate | uppercase }}</span>
      </button>
      <button type="submit" mat-raised-button class="primary-button" [disabled]="!profileForm.valid || (isLoading$ | async)">
        <span>{{ 'UI.Save' | translate | uppercase }}</span>
      </button>
    </mat-dialog-actions>
  </form>
} @else {
  <div class="spinner cf-flex-1 cf-flex-column cf-justify-content-center cf-align-items-center">
    <app-spinner></app-spinner>
  </div>
}
